import { render, staticRenderFns } from "./DeleteResourceSupplier.vue?vue&type=template&id=b51514b6"
import script from "./DeleteResourceSupplier.vue?vue&type=script&lang=js"
export * from "./DeleteResourceSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports